export default __webpack_public_path__ + "static/media/ci-segment-frequent.9665217c.svg";